import { mergeColumns, getVisibleItems } from '../../../../itrust_common/utils/orderingPreferencesUtils'

export const QUICK_ACTION_DEFAULTS = [
  { key: 'patient', visible: true, order: 1 },
  { key: 'appointment', visible: true, order: 2 },
  { key: 'exam', visible: true, order: 3 },
  { key: 'order', visible: true, order: 4 },
  { key: 'prescription', visible: true, order: 5 },
  { key: 'send_text_message', visible: true, order: 6 },
  { key: 'whatsapp', visible: true, order: 7 },
  { key: 'make_phone_call', visible: true, order: 8 },
  { key: 'add_insurance', visible: false, order: 9 },
  { key: 'add_contact_lens', visible: false, order: 10 },
  { key: 'add_contact', visible: false, order: 11 },
]

export const getQuickActionColumns = (savedColumns) => mergeColumns(QUICK_ACTION_DEFAULTS, savedColumns)

export const getVisibleQuickActions = (columns, isAllowed) => (
  getVisibleItems(columns, isAllowed)
)
